import type { Component } from "solid-js";
import { createResource, Show } from "solid-js";
import { useAuthDispatch } from "../state/auth";
import { Navigate } from "@solidjs/router";

const LoginCallbackPage: Component = () => {
  const { handleLoginCallback } = useAuthDispatch();
  const [origin] = createResource(() => handleLoginCallback());

  return (
    <Show when={origin.state === "ready" || origin.state === "errored"} fallback="Loading...">
      <Navigate href={origin() ?? "/"} />
    </Show>
  );
};

export default LoginCallbackPage;
